(() => {
  /**
   * Помечает документ классом, пока последним вводом был указатель (мышь,
   * палец, стилус). У полей ввода :focus-visible срабатывает и на клик, из-за
   * чего рамка фокуса выскакивала при обычном нажатии; CSS гасит её по этому
   * классу, оставляя индикацию для клавиатурной навигации (WCAG 2.4.7).
   * Штатный полифил темы для этого не годится: он включается только в
   * браузерах без поддержки :focus-visible.
   */
  const POINTER_CLASS = 'sb-pointer-focus';
  /** Клавиши, которыми переходят по интерфейсу: после них индикация нужна. */
  const NAV_KEYS = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'];

  const root = document.documentElement;

  window.addEventListener(
    'pointerdown',
    () => root.classList.add(POINTER_CLASS),
    { capture: true, passive: true }
  );

  window.addEventListener(
    'keydown',
    (event) => {
      if (NAV_KEYS.includes(event.key)) root.classList.remove(POINTER_CLASS);
    },
    { capture: true }
  );
})();
